export default "__VITE_ASSET__DoF9FYne__"